var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page_content"}},[_c('div',{attrs:{"id":"page_content_inner"}},[_c('cot-button'),_c('video-container',{attrs:{"section":"Revision"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }